// 9fbef606107a605d69c0edbcd8029e5d
import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import { getFormValues } from 'redux-form';
import PropTypes from 'prop-types';
import { List, Map } from 'immutable';
import { readCookie } from '@tcp/core/src/utils/cookie.util';
import BodyCopy from '@tcp/core/src/components/common/atoms/BodyCopy';
import { getAddressListState } from '@tcp/core/src/components/features/account/AddressBook/container/AddressBook.selectors';
import {
  getUserZipCode,
  getLoyaltyInformation,
} from '@tcp/core/src/components/features/account/User/container/User.selectors';
import BagPageSelector from '@tcp/core/src/components/features/CnC/BagPage/container/BagPage.selectors';
import CheckoutSelectors from '@tcp/core/src/components/features/CnC/Checkout/container/Checkout.selector';
import {
  getIsInternationalShipping,
  getHolidayMessage,
  getIsLoyaltyTieringEnabled,
} from '@tcp/core/src/reduxStore/selectors/session.selectors';
import {
  getEcomSkuParams,
  orderIncludesPurelyPreOrderItems,
} from '@tcp/core/src/components/features/CnC/CartItemTile/container/CartItemTile.selectors';
import { compose } from 'redux';
import withDynamicSaga from '@tcp/core/src/components/common/hoc/withDynamicSaga';
import withDynamicReducer from '@tcp/core/src/components/common/hoc/withDynamicReducer';
import EddReducer from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.reducer';
import EddSaga from '@tcp/core/src/components/features/CnC/common/molecules/EddComponent/container/EddComponent.saga';
import { getLoyaltyTierBenefits } from '@tcp/core/src/components/features/account/PlaceRewards/container/PlaceRewards.selectors.js';
import EddComponentView from '../views';
import {
  getEddFeatureSwitch,
  getEddAllowedStates,
  getItemsWithEDD,
  getOrderEddDates,
  getFetchingState,
  getEddErrorState,
  getEddABState,
  getSelectedShippingCode,
} from './EddComponent.selectors';
import { getEddData, updateShippingCode, resetEddError, clearEddTTL } from './EddComponent.actions';

export class EddComponent extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      tcpState: null,
      tcpZip: null,
    };
  }

  componentDidMount() {
    this.getState();
    this.getZip();
  }

  componentWillUnmount() {
    const { resetEddErrorActn, itemIndex, fromCartTile } = this.props;
    if (!fromCartTile || itemIndex === 0) resetEddErrorActn();
  }

  getDefaultZipCode = () => {
    const { addressList, shippingZip, shippingCheckoutAddress, shippingFormValues } = this.props;
    const { tcpZip } = this.state;
    let zipcode = null;
    const shippingZipValue = shippingFormValues?.zipCode;
    if (shippingZipValue) {
      zipcode = shippingZipValue;
    } else if (shippingCheckoutAddress && shippingCheckoutAddress.zipCode) {
      //  first pick address from checkout shipping address
      zipcode = shippingCheckoutAddress.zipCode;
    } else if (List.isList(addressList) && addressList.size) {
      // first pick the zipcode from shipping address from addressbook
      zipcode = this.getZipCodeFromList(addressList);
    } else if (shippingZip) {
      // then pick the zipcode from shipping adderess from orderDetails state
      zipcode = shippingZip;
    } else {
      zipcode = tcpZip;
    }
    return zipcode;
  };

  getDefaultAddressFromList = (addressList) => {
    return addressList.find(
      (address) => address.primary === 'true' || address?.preferred === 'true'
    );
  };

  getZipCodeFromList = (addressList) => {
    const defaultAddress =
      List.isList(addressList) && addressList.size && this.getDefaultAddressFromList(addressList);
    return defaultAddress && (defaultAddress.zipCode || defaultAddress?.postalCode);
  };

  getStateCodeFromList = (addressList) => {
    const defaultAddress =
      List.isList(addressList) && addressList.size && this.getDefaultAddressFromList(addressList);
    return defaultAddress && (defaultAddress.state || defaultAddress?.stateCode);
  };

  getState = () => {
    const tcpStatePromise = readCookie('tcpState');
    if (tcpStatePromise) {
      this.setState({ tcpState: tcpStatePromise });
    }
  };

  getReturnZip = () => {
    const tcpZipPromise = readCookie('tcpZip');
    let zipcode = null;
    if (tcpZipPromise) {
      zipcode = tcpZipPromise;
    }
    return zipcode;
  };

  getZip = () => {
    const tcpZipPromise = readCookie('tcpZip');
    if (tcpZipPromise) {
      this.setState({ tcpZip: tcpZipPromise });
    }
  };

  getStateFromAddress = (addressList) => {
    const { tcpState } = this.state;
    const { shippingState, shippingCheckoutAddress, shippingFormValues } = this.props;
    let statecode = null;
    const shippingStateValue = shippingFormValues?.state;
    if (shippingStateValue) {
      statecode = shippingStateValue;
    } else if (shippingCheckoutAddress && shippingCheckoutAddress.state) {
      //  first pick address from checkout shipping address
      statecode = shippingCheckoutAddress.state;
    } else if (List.isList(addressList) && addressList.size) {
      // second pick the state code from shipping address from addressbook
      statecode = this.getStateCodeFromList(addressList);
    } else if (shippingState) {
      // then pick the state code from shipping adderess from orderDetails state
      statecode = shippingState;
    } else {
      statecode = tcpState;
    }
    return statecode;
  };

  checkStateEligibility = (stateAddress) => {
    const { eddAllowedStates } = this.props;
    const eddAllowedStatesArr = eddAllowedStates.split('|');
    return eddAllowedStatesArr && eddAllowedStatesArr.length > 0
      ? eddAllowedStatesArr.indexOf(stateAddress) > -1
      : false;
  };

  fetchEddData = () => {
    const {
      cartOrderItems,
      getEdd,
      currentOrderId,
      addressList,
      newBag,
      fromCartTile,
      itemIndex,
      isPDP,
      isQuickView,
    } = this.props;
    const zipcode = this.getDefaultZipCode();
    const stateAddress = this.getStateFromAddress(addressList);
    const skuData = (cartOrderItems && getEcomSkuParams(cartOrderItems, newBag)) || [];
    if (
      (!fromCartTile || itemIndex === 0) &&
      this.checkStateEligibility(stateAddress) &&
      skuData.length &&
      zipcode &&
      !isPDP &&
      !isQuickView
    ) {
      const payload = {
        skuList: skuData,
        orderId: currentOrderId && currentOrderId.toString(),
        state: stateAddress,
        zipCode: zipcode,
      };
      getEdd(payload);
    }
  };

  isEddEligbleCountry = () => {
    const { isInternationalShipping } = this.props;
    return !isInternationalShipping;
  };

  triggerEdd = () => {
    const { isEDD, eddError } = this.props;
    if (isEDD && !eddError && this.isEddEligbleCountry()) {
      this.fetchEddData();
    }
  };

  triggerEddOnUpdate = () => {
    const tcpZipPromise = this.getReturnZip();
    const zipCode = this.getDefaultZipCode();
    const isZipSame = tcpZipPromise !== zipCode;
    const { isEDD, itemsWithEdd, isFetchingState, eddError } = this.props;
    if (
      isEDD &&
      !eddError &&
      (!itemsWithEdd || isZipSame) &&
      !isFetchingState &&
      this.isEddEligbleCountry()
    ) {
      this.fetchEddData();
    }
  };

  render() {
    const {
      isEDD,
      placeHolderText,
      fontSize,
      preOrderItemsIncluded,
      subtitle,
      loyaltyTierBenefits,
      loyaltyInformation,
      ...otherProps
    } = this.props;
    const subtitleUpdate = subtitle === 'FREE Standard Shipping' ? 'FREE Shipping' : '';
    const currentTier = loyaltyInformation?.get('currentTier');
    const hasExpeditedProcessing =
      Array.isArray(loyaltyTierBenefits) &&
      loyaltyTierBenefits.length > 0 &&
      loyaltyTierBenefits.some((benefit) => benefit.type === 'ExpeditedProcessing');
    return isEDD ? (
      <EddComponentView
        fetchEdd={this.triggerEdd}
        fetchEddUpdate={this.triggerEddOnUpdate}
        placeHolderText={placeHolderText}
        fontSize={fontSize}
        preOrderItemsIncluded={preOrderItemsIncluded}
        subtitle={subtitle}
        hasExpeditedProcessing={hasExpeditedProcessing}
        currentTier={currentTier}
        {...otherProps}
      />
    ) : (
      <>
        {placeHolderText ? (
          <BodyCopy
            fontFamily="secondary"
            fontSize={fontSize || 'fs14'}
            component="p"
            textAlign="center"
            color="green.500"
          >
            {placeHolderText}
          </BodyCopy>
        ) : (
          subtitleUpdate && (
            <BodyCopy
              fontFamily="secondary"
              fontSize={fontSize || 'fs14'}
              component="p"
              textAlign="center"
              color="green.500"
              fontWeight="extrabold"
            >
              {subtitleUpdate}
            </BodyCopy>
          )
        )}
      </>
    );
  }
}

export const mapStateToProps = (state) => ({
  isEDD: getEddFeatureSwitch(state),
  eddAllowedStates: getEddAllowedStates(state),
  addressList: getAddressListState(state),
  profileZipCode: getUserZipCode(state),
  cartOrderItems: BagPageSelector.getOrderItems(state),
  isBossBopisOrder: BagPageSelector.getBossStatus(state) || BagPageSelector.getBopisStatus(state),
  isInternationalShipping: getIsInternationalShipping(state),
  itemsWithEdd: getItemsWithEDD(state),
  orderEddDates: getOrderEddDates(state),
  isFetchingState: getFetchingState(state),
  eddError: getEddErrorState(state),
  currentOrderId: BagPageSelector.getCurrentOrderId(state),
  isEddABTest: getEddABState(state),
  shippingState: BagPageSelector.getShippingAddressState(state),
  shippingZip: BagPageSelector.getShippingAddressZip(state),
  shippingCheckoutAddress: CheckoutSelectors.getShippingAddress(state),
  selectedShippingMethod:
    getSelectedShippingCode(state) || CheckoutSelectors.getSavedShippingMethodCode(state),
  shippingMethodSelected: CheckoutSelectors.getSavedShippingMethod(state),
  shippingFormValues: getFormValues('ShippingForm')(state),
  preOrderItemsIncluded: orderIncludesPurelyPreOrderItems(state),
  holidayMessageEnabled: getHolidayMessage(state),
  isLoyaltyTieringEnabled: getIsLoyaltyTieringEnabled(state),
  loyaltyTierBenefits: getLoyaltyTierBenefits(state),
  loyaltyInformation: getLoyaltyInformation(state),
});

export const mapDispatchToProps = (dispatch) => ({
  getEdd: (payload) => {
    dispatch(getEddData(payload));
  },
  updateShipmentCode: (payload) => {
    dispatch(updateShippingCode(payload));
  },
  resetEddErrorActn: () => {
    dispatch(resetEddError());
    dispatch(clearEddTTL());
  },
});

EddComponent.propTypes = {
  itemsWithEdd: PropTypes.shape({}).isRequired,
  cartOrderItems: PropTypes.shape({}),
  addressList: PropTypes.shape([]),
  eddAllowedStates: PropTypes.shape([]),
  isEDD: PropTypes.bool,
  getEdd: PropTypes.func.isRequired,
  isBossBopisOrder: PropTypes.bool,
  profileZipCode: PropTypes.string,
  isInternationalShipping: PropTypes.bool,
  isFetchingState: PropTypes.bool,
  currentOrderId: PropTypes.string,
  eddError: PropTypes.bool,
  shippingZip: PropTypes.string,
  shippingState: PropTypes.string,
  shippingCheckoutAddress: PropTypes.shape({}),
  resetEddErrorActn: PropTypes.func,
  shippingMethodSelected: PropTypes.shape({}).isRequired,
  shippingFormValues: PropTypes.shape({}).isRequired,
  clearEddTTLActn: PropTypes.func.isRequired,
  subtitle: PropTypes.string,
  itemIndex: PropTypes.number,
  fromCartTile: PropTypes.bool,
  loyaltyTierBenefits: PropTypes.shape({}),
  loyaltyInformation: Map({ currentTier: '' }),
};

EddComponent.defaultProps = {
  isEDD: false,
  cartOrderItems: null,
  addressList: null,
  isBossBopisOrder: false,
  profileZipCode: null,
  eddAllowedStates: [],
  isInternationalShipping: false,
  isFetchingState: false,
  currentOrderId: '',
  eddError: false,
  shippingZip: '',
  shippingState: '',
  shippingCheckoutAddress: null,
  resetEddErrorActn: () => {},
  subtitle: '',
  itemIndex: null,
  fromCartTile: false,
  loyaltyTierBenefits: {},
  loyaltyInformation: {},
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);
const withSaga = withDynamicSaga({ key: 'EddSaga', saga: EddSaga });
const withReducer = withDynamicReducer({ key: 'Edd', reducer: EddReducer });

export default compose(withReducer, withSaga, withConnect)(EddComponent);
